import { useState, useEffect, useRef } from 'react'
import { C } from '../landing.theme'
import { Ic } from '../ui/Ic'
import { Fade } from '../ui/Fade'

const STATS = [
  { raw: '500+', label: 'позиций',  num: 500, suffix: '+', text: null },
  { raw: 'с 2019', label: 'на рынке', num: null, suffix: '', text: 'с 2019' },
  { raw: '12+',  label: 'брендов',  num: 12,  suffix: '+', text: null },
  { raw: '50+',  label: 'объектов', num: 50,  suffix: '+', text: null },
]

const STARS = [[42,28,.8,.7],[80,16,1.1,.55],[122,22,.7,.65],[178,10,.95,.8],[228,30,.7,.5],[272,18,1.0,.65],[318,26,.85,.7],[358,13,.9,.45],[30,52,.65,.4],[98,44,.75,.5],[195,48,.65,.42],[305,38,.8,.5],[375,33,.6,.45],[55,70,.6,.35],[145,60,.7,.4],[240,65,.65,.38],[340,58,.7,.4]]
const WIN_LIGHTS = [[36,214],[43,209],[102,202],[105,206],[80,209],[125,210],[165,211],[184,217],[219,219]]

/* ── Count-up for all animatable stats at once ── */
function useStatsCountUp(targets, duration = 1400) {
  const [counts, setCounts] = useState(() => targets.map(() => 0))
  const ref = useRef(null)
  useEffect(() => {
    const el = ref.current
    if (!el) return
    const ob = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return
      ob.disconnect()
      const start = performance.now()
      const tick = (now) => {
        const p = Math.min((now - start) / duration, 1)
        const eased = 1 - Math.pow(1 - p, 3)
        setCounts(targets.map(t => t !== null ? Math.round(eased * t) : null))
        if (p < 1) requestAnimationFrame(tick)
      }
      requestAnimationFrame(tick)
    }, { threshold: 0.3 })
    ob.observe(el)
    return () => ob.disconnect()
  }, [duration]) // eslint-disable-line
  return [counts, ref]
}

export default function About() {
  const [counts, statsRef] = useStatsCountUp(STATS.map(s => s.num), 2600)

  return (
    <section className="sec" id="about" style={{ background: C.bg2, position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: 0, right: 0, width: '42%', height: '100%', background: 'radial-gradient(circle at 72% 38%,rgba(15,163,177,.065),transparent 68%)', pointerEvents: 'none' }}/>
      <div className="wrap">
        <div className="g-about" style={{ display: 'grid', gridTemplateColumns: '1.1fr .9fr', gap: 52, alignItems: 'center', position: 'relative', zIndex: 2 }}>
          <Fade>
            <span className="eb">О КОМПАНИИ · WELLAND · АЛМАТЫ, КЗ</span>
            <h2 style={{ fontSize: 'clamp(26px,4vw,42px)', color: '#fff', marginTop: 16 }}>Надёжный партнёр<br/>в оснащении бассейнов</h2>
            <p style={{ color: C.s2, fontSize: 16.5, lineHeight: 1.72, marginTop: 18, maxWidth: 500 }}>С 2019 года Welland помогает частным клиентам, застройщикам и СПА-комплексам Казахстана профессионально подбирать и поставлять оборудование для бассейнов.</p>
            <p style={{ color: C.s3, fontSize: 15, lineHeight: 1.68, marginTop: 12, maxWidth: 500 }}>Работаем напрямую с ведущими мировыми - Emaux, Pahlen, CGT, Reviglass и другими. Наши специалисты сопровождают сделку от технического подбора до финальной поставки.</p>

            <div ref={statsRef} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '18px 32px', marginTop: 32, maxWidth: 440 }}>
              {STATS.map((s, i) => {
                const display = s.text !== null
                  ? s.text
                  : `${counts[i]}${s.suffix}`
                return (
                  <div key={s.label} style={{ borderLeft: `2px solid ${C.teal}`, paddingLeft: 14 }}>
                    <b style={{ display: 'block', fontSize: 'clamp(22px,2.6vw,30px)', fontWeight: 900, color: '#fff', letterSpacing: '-.02em', fontVariantNumeric: 'tabular-nums' }}>
                      {display}
                    </b>
                    <span style={{ fontSize: 13, color: C.s3 }}>{s.label}</span>
                  </div>
                )
              })}
            </div>
          </Fade>

          <Fade delay={120}>
            <div style={{ aspectRatio: '4/3.4', borderRadius: 26, overflow: 'hidden', background: 'linear-gradient(180deg,#020a18 0%,#031320 45%,#051a2c 100%)', border: `1px solid ${C.line}`, boxShadow: '0 28px 80px rgba(0,0,0,.65)', position: 'relative' }}>
              <div style={{ position: 'absolute', inset: 0, backgroundImage: `linear-gradient(rgba(31,200,214,.07) 1px,transparent 1px),linear-gradient(90deg,rgba(31,200,214,.07) 1px,transparent 1px)`, backgroundSize: '26px 26px', WebkitMaskImage: 'radial-gradient(ellipse 90% 55% at 50% 18%,#000,transparent)', maskImage: 'radial-gradient(ellipse 90% 55% at 50% 18%,#000,transparent)', zIndex: 1 }}/>
              <svg viewBox="0 0 400 270" preserveAspectRatio="xMidYMax slice" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', zIndex: 2 }}>
                <defs>
                  <linearGradient id="amg0" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#0d3d52" stopOpacity="0.32"/>
                    <stop offset="100%" stopColor="#020c18" stopOpacity="0.05"/>
                  </linearGradient>
                  <linearGradient id="amg1" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#0c4d62" stopOpacity="0.72"/>
                    <stop offset="100%" stopColor="#031322" stopOpacity="0.5"/>
                  </linearGradient>
                  <linearGradient id="amg2" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#072e3c" stopOpacity="0.95"/>
                    <stop offset="100%" stopColor="#010810" stopOpacity="1"/>
                  </linearGradient>
                  <linearGradient id="acityGlow" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#1FC8D6" stopOpacity="0.18"/>
                    <stop offset="100%" stopColor="#1FC8D6" stopOpacity="0"/>
                  </linearGradient>
                  <radialGradient id="apkG1" cx="38%" cy="30%" r="22%">
                    <stop offset="0%" stopColor="#1FC8D6" stopOpacity="0.14"/>
                    <stop offset="100%" stopColor="#1FC8D6" stopOpacity="0"/>
                  </radialGradient>
                  <radialGradient id="apkG2" cx="66%" cy="32%" r="18%">
                    <stop offset="0%" stopColor="#1FC8D6" stopOpacity="0.10"/>
                    <stop offset="100%" stopColor="#1FC8D6" stopOpacity="0"/>
                  </radialGradient>
                </defs>
                <ellipse cx="152" cy="88" rx="90" ry="60" fill="url(#apkG1)"/>
                <ellipse cx="265" cy="95" rx="75" ry="55" fill="url(#apkG2)"/>
                {STARS.map(([cx, cy, r, op], k) => (
                  <circle key={k} cx={cx} cy={cy} r={r} fill="#fff" opacity={op}/>
                ))}
                <path d="M0 270 L0 148 L22 122 L48 142 L78 105 L108 130 L138 88 L165 116 L192 96 L220 124 L252 82 L282 112 L310 94 L340 120 L368 100 L400 118 L400 270 Z" fill="url(#amg0)"/>
                <path d="M0 270 L0 172 L18 152 L42 168 L70 132 L96 155 L124 112 L148 140 L172 120 L198 146 L225 126 L254 150 L280 130 L308 152 L334 134 L362 155 L400 140 L400 270 Z" fill="url(#amg1)" stroke="rgba(31,200,214,.22)" strokeWidth="0.6"/>
                <path d="M0 270 L0 196 L16 180 L38 193 L62 166 L86 183 L112 152 L136 174 L158 162 L180 177 L205 164 L228 180 L252 162 L276 180 L300 164 L326 180 L352 166 L378 180 L400 172 L400 270 Z" fill="url(#amg2)" stroke="rgba(31,200,214,.38)" strokeWidth="1"/>
                <rect x="0" y="216" width="400" height="30" fill="url(#acityGlow)"/>
                <path d="M0 270 L0 232 L7 232 L7 226 L11 226 L11 222 L15 222 L15 218 L19 218 L19 222 L23 222 L23 228 L27 228 L27 220 L31 220 L31 216 L35 216 L35 212 L38 212 L38 208 L42 208 L42 212 L46 212 L46 216 L50 216 L50 220 L54 220 L54 215 L58 215 L58 210 L62 210 L62 215 L67 215 L67 220 L72 220 L72 213 L76 213 L76 208 L80 208 L80 213 L85 213 L85 220 L90 220 L90 214 L94 214 L94 209 L98 209 L98 205 L101 205 L101 201 L104 201 L104 205 L107 205 L107 209 L111 209 L111 214 L116 214 L116 219 L120 219 L120 213 L124 213 L124 208 L128 208 L128 213 L133 213 L133 219 L138 219 L138 213 L142 213 L142 209 L146 209 L146 213 L151 213 L151 220 L158 220 L158 214 L163 214 L163 210 L167 210 L167 215 L173 215 L173 221 L180 221 L180 216 L185 216 L185 221 L192 221 L192 217 L198 217 L198 222 L208 222 L213 222 L213 218 L218 218 L218 222 L226 222 L400 222 L400 270 Z" fill="rgba(2,7,16,.92)"/>
                {WIN_LIGHTS.map(([x, y], k) => (
                  <rect key={k} x={x} y={y} width="1.8" height="1.8" rx="0.4" fill={k % 2 === 0 ? '#1FC8D6' : '#0FA3B1'} opacity={0.55 + k % 3 * 0.1}/>
                ))}
              </svg>
              <div style={{ position: 'absolute', top: '33%', left: '50%', transform: 'translate(-50%,-50%)', width: 52, height: 52, borderRadius: '50%', background: C.teal, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 0 10px rgba(15,163,177,.16),0 0 0 20px rgba(15,163,177,.07),0 14px 32px rgba(0,0,0,.45)', animation: 'floatY 3s ease-in-out infinite', zIndex: 3 }}>
                <span style={{ color: '#032a2f' }}><Ic n="pin" s={26}/></span>
              </div>
              <div style={{ position: 'absolute', bottom: 18, left: 20, zIndex: 3 }}>
                <b style={{ display: 'block', color: '#fff', fontSize: 17, fontWeight: 800, letterSpacing: '.01em' }}>Алматы</b>
                <span style={{ fontSize: 12, color: C.s3, fontFamily: "'JetBrains Mono',monospace" }}>welland.info@mail.ru · +7 (777) 229-62-25</span>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </section>
  )
}
